import { FeatureFlagRuleInput } from './types';

// Mirrors the backend's FeatureFlagRuleInputValidator so the admin sees which rule is wrong
// inline instead of a single opaque 400 from the save call. Error codes rather than strings:
// translation happens in the components that render them.
export type RulePriorityError = 'not-positive' | 'duplicate';
export type RuleValuesError = 'required';

export interface RuleError {
    priority?: RulePriorityError;
    values?: RuleValuesError;
}

export type RuleErrors = (RuleError | null)[];

export function validateRules(rules: FeatureFlagRuleInput[]): RuleErrors {
    const priorityCounts = new Map<number, number>();
    for (const rule of rules) {
        const seen = priorityCounts.get(rule.priority);
        priorityCounts.set(rule.priority, seen === undefined ? 1 : seen + 1);
    }

    return rules.map((rule) => {
        const error: RuleError = {};

        // Clearing the number field yields Number('') === 0, which the backend rejects; so does
        // any non-integer priority, since precedence is compared as whole numbers.
        if (!Number.isInteger(rule.priority) || rule.priority < 1) {
            error.priority = 'not-positive';
        } else if ((priorityCounts.get(rule.priority) as number) > 1) {
            error.priority = 'duplicate';
        }

        // An empty rule is either meaningless (In) or accidentally global (NotIn matches everyone
        // holding that attribute), which is why the backend refuses it.
        if (rule.values.length === 0) {
            error.values = 'required';
        }

        return error.priority !== undefined || error.values !== undefined ? error : null;
    });
}

export function hasRuleErrors(errors: RuleErrors): boolean {
    return errors.some((error) => error !== null);
}
